
import React, { useEffect } from 'react';
import ProBg from "./proBg.jpg"

const MsRail = () => {
    useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when this page loads
  }, []);
  return (
    <div>
      <section
        className="featured-job-area section-padding30 section-bg2"
        style={{
          backgroundImage: `url(${ProBg})`, backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '400px',  // Adjust the height here
        }}
      >
        <div className="container">
          <div className="row justify-content">
            <div className="col-xl-7 col-lg-9 col-md-10 col-sm-12">
              {/* Section Title */}
              <div className="section-tittle text-left mb-80">
                <h2>MS Rail</h2>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            {/* Add content here */}
          </div>
        </div>
      </section>

      <section className="about-low-area section-padding2" style={{ marginTop: '-50px' }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-10">
              <div className="about-caption mb-11">
                <div className="section-tittle mb-11">
                  {/* <span>About Al Hadeed Steel</span> */}
                  {/* <h2>Building the Future with Strength and Durability</h2> */}
                </div>
                <p style={{lineHeight:"2.4"}}>
<p><strong>The track on a railway or railroad</strong>, also known as the <strong>permanent way</strong>, is the structure consisting of the <strong>rails</strong>, <strong>fasteners</strong>, <strong>railroad ties</strong> (or <strong>sleepers</strong> in British English) and <strong>ballast</strong> (or <strong>slab track</strong>), along with the underlying <strong>subgrade</strong>. It provides the foundation for trains to move by offering a reliable surface for their wheels to roll. To avoid confusion, it is often referred to as <strong>railway track</strong> (in British English and UIC terminology) or <strong>railroad track</strong> (primarily in the United States). Tracks that accommodate <strong>electric trains</strong> or <strong>electric trams</strong> are equipped with an <strong>electrification system</strong>, such as an <strong>overhead electrical power line</strong> or an additional <strong>electrified rail</strong>.</p>

<p><strong>Modern track</strong> typically uses <strong>hot-rolled steel</strong> with an asymmetrical rounded I-beam profile. Unlike other uses of <strong>iron</strong> and <strong>steel</strong>, <strong>railway rails</strong> are subjected to very high <strong>stresses</strong> and must be made from high-quality <strong>steel alloys</strong>. It took many decades to enhance the materials, including the transition from <strong>iron</strong> to <strong>steel</strong>. The stronger the rails and the rest of the <strong>trackwork</strong>, the heavier and faster the <strong>trains</strong> the track can support.</p>

<p>Other types of rail profiles include: <strong>bullhead rail</strong>, <strong>grooved rail</strong>, <strong>flat-bottomed rail</strong> (such as <strong>Vignoles rail</strong> or <strong>flanged T-rail</strong>), <strong>bridge rail</strong> (inverted U–shaped used in baulk road), and <strong>Barlow rail</strong> (inverted V).</p>

<p>North American <strong>railroads</strong>, until the mid- to late-20th century, used rails that were <strong>39 ft (11.89 m)</strong> long so that they could be transported in <strong>gondola cars</strong> (open <strong>wagons</strong>), typically <strong>40 ft (12.2 m)</strong> long. As the size of <strong>gondola cars</strong> increased, so did the lengths of the <strong>rails</strong>.</p>

<p>According to the <strong>Railway Gazette</strong>, the <strong>150-kilometre rail line</strong> being constructed for the <strong>Baffinland Iron Mine</strong> on <strong>Baffin Island</strong> will use older <strong>carbon steel alloys</strong> for its rails, as opposed to more modern, higher-performance alloys, because modern <strong>alloy rails</strong> can become <strong>brittle</strong> at extremely low temperatures.</p>
 </p>
                
              </div>
            </div>
          </div>
           
        </div>
      </section>
    </div>
  );
}

export default MsRail;
